import { render, staticRenderFns } from "./LoginSection.vue?vue&type=template&id=0bbcf314&"
import script from "./LoginSection.vue?vue&type=script&lang=js&"
export * from "./LoginSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports